"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const logrocket_1 = __importDefault(require("logrocket"));
const react_1 = __importDefault(require("react"));
const react_div_100vh_1 = __importDefault(require("react-div-100vh"));
const components_1 = require("@/components");
const modals_1 = require("@/modals");
const config_1 = __importDefault(require("../config"));
const context_1 = require("./context");
const styles_scss_1 = __importDefault(require("./styles.scss"));
class App extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = context_1.initialValues;
    }
    componentDidMount() {
        if (config_1.default.sentry) {
            Sentry.init({
                dsn: config_1.default.sentry.token,
                integrations: [new tracing_1.Integrations.BrowserTracing()],
                tracesSampleRate: 1.0,
                environment: config_1.default.sentry.environment,
            });
        }
        if (config_1.default.logrocket) {
            logrocket_1.default.init(config_1.default.logrocket.token, { release: config_1.default.version });
            if (config_1.default.sentry) {
                Sentry.configureScope((scope) => {
                    scope.addEventProcessor((eventData) => __awaiter(this, void 0, void 0, function* () {
                        const newData = Object.assign({}, eventData);
                        newData.extra.sessionURL = logrocket_1.default.sessionURL;
                        return newData;
                    }));
                });
            }
        }
    }
    render() {
        const { children } = this.props;
        return (react_1.default.createElement(context_1.AppContext.Provider, { value: this.state },
            react_1.default.createElement(react_div_100vh_1.default, { className: styles_scss_1.default.appContainer },
                react_1.default.createElement("div", { className: styles_scss_1.default.main },
                    react_1.default.createElement(components_1.Header, null),
                    react_1.default.createElement("div", { className: styles_scss_1.default.content }, children),
                    react_1.default.createElement(components_1.Footer, null))),
            react_1.default.createElement(components_1.Modal
            // @ts-ignore
            , { 
                // @ts-ignore
                modals: {
                    [modals_1.ModalNames.USER_DELETE]: ({ content }) => content[modals_1.ModalNames.USER_DELETE] || react_1.default.createElement("div", null),
                    [modals_1.ModalNames.THERAPY_NOTE_DELETE]: ({ content }) => content[modals_1.ModalNames.THERAPY_NOTE_DELETE] || react_1.default.createElement("div", null),
                    [modals_1.ModalNames.PROGRAM_DELETE]: ({ content }) => content[modals_1.ModalNames.PROGRAM_DELETE] || react_1.default.createElement("div", null),
                    [modals_1.ModalNames.SECTION_DELETE]: ({ content }) => content[modals_1.ModalNames.SECTION_DELETE] || react_1.default.createElement("div", null),
                } }),
            react_1.default.createElement(components_1.Version, { version: config_1.default.version })));
    }
}
exports.App = App;
exports.default = App;
